<div class="flex--row">
  <form [formGroup]="formGroup">
    <mat-form-field
      class="flex__child--auto spacing--margin-right spacing--margin-half-top filterDatePicker text--small"
      subscriptSizing="dynamic"
    >
      <input
        #startDate
        matInput
        formControlName="startDate"
        [placeholder]="'dateFrom' | translate"
        [matDatepicker]="startDatePicker"
        data-test="deliveries-overview-filter__startDate"
      />
      <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #startDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="flex__child--auto spacing--margin-right filterDatePicker text--small"
      subscriptSizing="dynamic"
    >
      <input
        #endDate
        matInput
        formControlName="endDate"
        [placeholder]="'dateTo' | translate"
        [matDatepicker]="endDatePicker"
        data-test="deliveries-overview-filter__endDate"
      />
      <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #endDatePicker></mat-datepicker>
    </mat-form-field>

    <button
      *ngIf="(isMobile$ | async) === false"
      class="flex__child--auto spacing--margin-right"
      mat-flat-button
      color="primary"
      [disabled]="!isValid()"
      (click)="applyFilter()"
      data-test="deliveries-overview-filter__search"
    >
      <mat-icon>search</mat-icon> {{ 'search' | translate }}
    </button>

    <button
      *ngIf="isMobile$ | async"
      class="flex__child--auto spacing--margin-right"
      mat-icon-button
      [disabled]="!isValid()"
      (click)="applyFilter()"
      data-test="deliveries-overview-filter__search"
    >
      <mat-icon>search</mat-icon>
    </button>
  </form>
</div>
